import React from 'react'
import { Title } from '@fs/zion-head'
import { useTranslation } from 'react-i18next'
import { useLocation } from '@fs/zion-router'

export default function PageTitle() {
  const [t] = useTranslation()
  const location = useLocation()

  // NOTE: This does not handle all page titles. In some cases, the title needs specific data we don't have here.
  // SeriesDetailPage, SessionDetailPage, VirtualBoothPage, and SpeakerDetailPage set their own title.

  const titleMap = {
    '/series': t('navigation.series.label', 'Guide Me'),
    '/search': t('navigation.sessions.label', 'Sessions'),
    '/calendar': t('navigation.calendar.label', 'Calendar'),
    '/speakers': t('navigation.speakers.label', 'Speakers'),
    '/expohall': t('navigation.expo-hall.label', 'Expo Hall'),
    '/volunteer/support': t('navigation.support.label', 'Support'),
    '/playlist': t('navigation.my-playlist.label', 'My Playlist'),
    '/user': t('navigation.user.label', 'User'),
    '/home': t('navigation.home.label', 'Home'),
    '/': t('navigation.home.label', 'Home'),
  }
  const path = titleMap[location.pathname]
  return (
    <Title breadcrumbs={path ? [t('site-title', 'RootsTech 2021')] : undefined}>
      {path || t('site-title', 'RootsTech 2021')}
    </Title>
  )
}
